import React, { useState } from 'react';
import AuthBg from '../../component/auth/AuthBg';
import Heading from '../../component/Heading/Heading';
import { useNavigate } from 'react-router';
import InputComponent from '../../component/input/Input';
import CommonButton from '../../component/button/Button';
import { sendPasswordVerification } from '../../services/authenticationService';
import Toast from '../../component/toastify/Index';
import logo from "../../assets/icons/logo.svg";
import "../../styles/pages/auth/signUp.scss"
import "../../styles/pages/auth/forgotPassword.scss"
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const handleChange = (e) => {
        setEmail(e.target.value);
        setError('');
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!email || !emailRegex.test(email)) {
            setError(`${t('common_is_valid_email')}`);
            return;
        }

        try {
            const response = await sendPasswordVerification({ email });
            if (response?.isSuccess) {
                navigate(`/send-mail/${email}`)
                Toast(response?.message, "success");
            }
        } catch (error) {
            Toast(error?.message, "error");
        }
    };

    return (
        <div className="auth forgot-password">
            <div className="signup-container">
                <Grid container>
                    <Grid item size={{ xs: 12, md: 6, lg: 4 }} className="min-vh-100">
                        <div className="logo-container">
                            <img src={logo} alt="logo" className='company-logo' />                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="signup-data">
                                <div className="input-container">
                                    <Heading text={t('common_text_forgot_password')} className="forgot-password-heading" />
                                    <div className="pt-2 forgot-mail">
                                        <label htmlFor="" className="">
                                            {t('common_label_enter_email_to_receive_otp')}
                                        </label>
                                        <InputComponent
                                            fullWidth
                                            type="text"
                                            placeholder={t('common_placeholder_email')}
                                            className="input-field"
                                            name="email"
                                            value={email}
                                            onChange={handleChange}
                                            error={!!error}
                                            isAuth
                                            helperText={error}
                                            margin="normal"
                                            variant="outlined"
                                        />
                                    </div>
                                </div>
                                <div className="signup-button">
                                    <CommonButton
                                        type="submit"
                                        text={t('common_text_send_verification')}
                                        className="submit-button w-100"
                                    />
                                </div>
                            </div>
                        </form>
                    </Grid>

                    <Grid item size={{ xs: 12, md: 6, lg: 8 }} className="signup-img-padding">
                        <AuthBg />
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default ForgotPassword;